export const TOPUP_CONFIG = {
  topupAmounts: [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600],
  topupAmountMin: 0.01,
  topupAmountMax: 600
}

export const TOPUP_AREA_MAX = 100
export const TOPUP_FIRST_AREA = 50
export const TOPUP_SECOND_AREA = TOPUP_AREA_MAX - TOPUP_FIRST_AREA

export const TOPUP_MODEL = {
  code: '',
  codeVerify: '',
  phone: null,
  email: null,
  amount: null,
  amountSelect: '',
  payment: '',
  firstArea: TOPUP_FIRST_AREA,
  secondArea: TOPUP_SECOND_AREA,
  agreement: false,
  agreeShare: false,
  agreeContact: false,
  useEmail: true,
  useSms: false
}

export const ENERGY_CODE_LENGTH = 16
